module.exports = {
  API_WINDOW_URL: 'http://borne.lastrolabe.org/api/public/api/fenetre/',
  API_BACKGROUND_URL: 'http://borne.lastrolabe.org/api/public/api/background/',
  API_USER_URL: 'http://borne.lastrolabe.org/api/public/api/user/',
  API_BACKGROUND_VEILLE_URL: 'http://borne.lastrolabe.org/api/public/api/background/veille/',
  API_VEILLE_URL : 'http://borne.lastrolabe.org/api/public/api/fenetre/veille/',
  API_TEMPS_VEILLE :'http://borne.lastrolabe.org/api/public/api/veille/'
}
